// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2VtAi","box":"WorkspacesBox_box__s8FPl","node":"WorkspacesBox_node__3_ezo"};